import { useEffect, useRef } from "react";
import { useT } from "@/lib/i18n";

/** Terminal-style live ticker showing captured behaviour events. */
export default function EventTicker({ events }) {
  const { t } = useT();
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [events.length]);
  return (
    <div className="iddl-ticker" data-testid="event-ticker">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2 flex items-center gap-4">
        <span className="opacity-60">{t("ticker.label")}</span>
        <div ref={ref} className="flex-1 overflow-x-auto whitespace-nowrap font-mono-disp">
          {events.length === 0 ? (
            <span className="opacity-50">{t("ticker.empty")}</span>
          ) : (
            events.slice(-12).map((e, i) => (
              <span key={i} className="mr-6">
                <span className="opacity-60">{e.time.toFixed(2)}s</span>{" "}
                <span>{e.event}</span>
                {e.detail && <span className="opacity-70">:{e.detail}</span>}
              </span>
            ))
          )}
        </div>
        <span className="opacity-50 hidden md:inline">{t("ticker.events", { n: events.length })}</span>
      </div>
    </div>
  );
}
